module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/step4-pict02-full-c138924329f90aa54a8386843c10043a.jpg";